import axiosInstance from "./axiosInstance";
export interface PortApi {
  portId: number;
  publicId: string;
  portName: string;
  portNameArabic: string;
  portShortName: string;
  arrivalShortName: string;
  departureShortName: string;
  portType: "A" | "R" | "W"; 
  isActive: boolean;
  deletedBy: number | null;
  deletedAt: string | null;
}

export interface PortListResponse {
  items: PortApi[];
  pageNo: number;
  pageSize: number;
  totalCount: number;
  pageNumber: number;
}
export interface PortListQuery {
  searchText?: string | null;
  isActive?: boolean | null;
  pageNo?: number;
  pageSize?: number;
}
export interface PortBlockPayload {
  fromDate: string;
  toDate: string;
  fromTime: string;
  toTime: string;
  reason: string;
}

export interface CreatePortPayload {
  portName: string;
  portNameArabic: string;
  portShortName: string;
  arrivalShortName: string;
  departureShortName: string;
  isActive: boolean;
  portType: "A" | "R" | "W";
  blocks: PortBlockPayload[];
}
export interface UpdatePortPayload {
  portId: number;
  publicId: string;
  portName: string;
  portNameArabic: string;
  portShortName: string;
  arrivalShortName: string;
  departureShortName: string;
  portType: "A" | "R" | "W";
  isActive: boolean;

  blocks: {
    portBlockId: number;
    fromDate: string;
    toDate: string;
    fromTime: string;
    toTime: string;
    reason: string;
  }[];

  deletedBy: number | null;
  deletedAt: string | null;
}

export interface UpdatePortBlockPayload {
  portBlockId: number;
  portId: number;
  fromDate: string;
  toDate: string;
  fromTime: string;
  toTime: string;
  reason: string;
}

export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getPorts = async (
  params: PortListQuery
): Promise<PortListResponse> => {
  const res = await axiosInstance.get("/Ports/list", {
    params,
    headers: getAuthHeader(),
  });

  return res.data;
};


export const createPortWithBlocks = async (payload: CreatePortPayload) => {
  const res = await axiosInstance.post(
    "/Ports/create-with-blocks",
    payload,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const getPortById = async (publicId: string) => {
  const res = await axiosInstance.get(`/Ports/${publicId}`, {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const updatePort = async (publicId: string, payload: UpdatePortPayload) => {
  const res = await axiosInstance.put(
    `/Ports/${publicId}`,
    payload,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const updatePortBlock = async (payload: UpdatePortBlockPayload) => {
  const res = await axiosInstance.post(
    "/Ports/block",
    { dto: payload },
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const deletePortBlock = async (publicId: string, blockId: number) => {
  const res = await axiosInstance.delete(
    `/Ports/${publicId}/blocks/${blockId}`,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const deletePort = async (publicId: string) => {
  const res = await axiosInstance.delete(
    `/Ports/${publicId}`,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};